/**
 * A fleet is a batch of flow runs started together and rate limited as one, named after whatever
 * asked for them: a scenario, an event trigger, an uploaded file.
 */
import { OneOrManySchema } from 'notable-common';
import { z } from 'zod';
import { FlowApiPageLimitSchema, FlowApiPageOffsetSchema } from '../pagination/pageLimit.js';
/** What a fleet's runs were started for, and so what its `kindId` points at. */
export var FlowRunFleetKind;
(function (FlowRunFleetKind) {
    FlowRunFleetKind["Scenario"] = "Scenario";
    FlowRunFleetKind["EventTrigger"] = "EventTrigger";
    FlowRunFleetKind["BulkTestUpload"] = "BulkTestUpload";
    FlowRunFleetKind["Flow"] = "Flow";
    FlowRunFleetKind["BulkReRunOrganization"] = "BulkReRunOrganization";
})(FlowRunFleetKind || (FlowRunFleetKind = {}));
/** Path parameters `GET /fleets/{fleetId}` accepts. */
export const FlowRunFleetIdParamsSchema = z.object({
    fleetId: z.uuid().describe('The fleet.'),
});
/** Query parameters `GET /fleets` accepts. */
export const FlowRunFleetListQuerySchema = z.object({
    id: OneOrManySchema(z.uuid()).describe('Return only these fleets.').optional(),
    organizationId: OneOrManySchema(z.uuid())
        .describe('Return only fleets of this organization, or of any of these organizations.')
        .optional(),
    kind: z.enum(FlowRunFleetKind).describe('Return only fleets started for this reason.').optional(),
    kindId: z
        .uuid()
        .describe('Return only fleets started by this scenario, trigger or flow.')
        .optional(),
    limit: FlowApiPageLimitSchema.describe('How many fleets to return.').optional(),
    offset: FlowApiPageOffsetSchema.describe('How many matches to skip, for paging.').optional(),
    orderBy: z.string().describe('Column to order by, such as created.').optional(),
    orderDirection: z.enum(['asc', 'desc']).describe('Direction to order by.').optional(),
});
//# sourceMappingURL=flowRunFleet.js.map